import { createEnv } from '@t3-oss/env-core'
import { z } from 'zod'

export const env = createEnv({
  clientPrefix: 'EVT_',
  client: {
    EVT_API_URL: z.string(),
    EVT_ALLOW_EXTERNAL: z.stringbool().default(false),
    EVT_DEFAULT_LIFF_ID: z.string(),
    EVT_SENTRY_DSN: z.string().optional(),
    EVT_MODE: z
      .enum(['development', 'production', 'staging'])
      .default('development'),
  },
  runtimeEnv: import.meta.env,
  emptyStringAsUndefined: true,
})
